import { Component, OnInit, Host, ViewChild, Input, Output, ElementRef, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Router } from "@angular/router";
import { MatPaginator, MatSort, MatSlideToggle } from '@angular/material';
import { saveAs as importedSaveAs } from "file-saver";
import * as moment from 'moment';

import { Contributor } from '../../../models/Contributor';
import { ContributorService } from './../../../services/contributor.service';
import { MatTableCustomDataSource, MatTableCustomApi, MatTableCustomDao } from './../../../helpers/mat-table-datasource';
import { AppComponent } from './../../../app.component';

@Component({
  selector: 'app-contributor-search-list',
  templateUrl: './contributor-search-list.component.html',
  styleUrls: ['./contributor-search-list.component.css'],
  providers: [ContributorService],
  encapsulation: ViewEncapsulation.None
})
export class ContributorSearchListComponent implements OnInit {
  // 'codice',
  displayedColumns = ['nome', 'cognome', '_id'];
  database: MatTableCustomDao<Contributor> | null;
  dataSource: MatTableCustomDataSource<Contributor, MatTableCustomApi<Contributor>>;

  printing: boolean = false;
  @Input() nested: boolean = false;
  @Output() notify: EventEmitter<Contributor> = new EventEmitter<Contributor>();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('qjolly') qjolly: ElementRef;

  filter: EventEmitter<any> = new EventEmitter<any>();

  confirm2remove: boolean = false;
  persisting: boolean = false;

  constructor(
    private router: Router,
    public contributorService: ContributorService,
    public parent: AppComponent) { }

  get filters(): any {
    console.log(this.qjolly.nativeElement.value)
    return {
      jolly: this.qjolly.nativeElement.value
    }
  }

  onFilterKeypress(event: KeyboardEvent) {
    if (event.keyCode == 13) {
      this.search();
    }
  }

  add() {
    this.router.navigate(['/contributor']);
  }

  edit() {
    this.router.navigate(['/contributor/' + this.contributorService.selected]);
  }

  remove() {
    if (this.contributorService.selected) {
      this.persisting = true;
      this.parent.addToast('', 'eliminazione in corso...', ((wid) => {
        setTimeout(() => {
          let item2remove = new Contributor({
            _id: this.contributorService.selectedId
          })
          this.contributorService.remove(item2remove).subscribe((res) => {
            console.log(res)
            if (res.success) {
              this.confirm2remove = false;
            }
            this.parent.clearToast(wid);
            this.search();
            this.persisting = false;
            this.parent.operSnackBar(res.success, res.success ? 'eliminazione completata' : res.err)
          })
        }, 1000);
      }))
    }
  }

  search() {
    this.filter.emit(this.filters);
  }

  choose() {
    console.log('chooooose', this.contributorService.selected)
    this.contributorService.getContributor(this.contributorService.selected).subscribe(result => {
      console.log(result)
      if (result.success && result.contributor) {
        this.notify.emit(new Contributor(result.contributor));
      }
    })
  }

  download() {
    this.parent.addToast('', 'estrazione in corso', ((wid) => {
      setTimeout(() => {
        // let wa = []
        // this.filters.forEach(o => {
        //   wa.push(o.q)
        // })
        this.contributorService.downloadFile(this.filters).subscribe(data => {
          let file = new Blob([data], { type: 'application/vnd.ms-excel' });
          importedSaveAs(file, 'contributors' + (moment().format('[-]YYYYMMDD[-]hhmmss')) + '.xlsx');
          this.parent.clearToast(wid);
          this.parent.operSnackBar(true, 'operazione completata');
        })
      }, 1000);
    }))
  }

  highlight(row) {
    this.contributorService.selected = row.codice;
    this.contributorService.selectedId = row._id;
  }

  ngOnInit() {
    this.database = new MatTableCustomDao(this.contributorService);
    this.dataSource = new MatTableCustomDataSource(
      this.database!,
      this.paginator,
      this.sort,
      this.filter,
      false);
  }

  getTitle(): string {
    return "contributors";
  }
}



// WEBPACK FOOTER //
// ./src/app/components/contributor/contributor-search-list/contributor-search-list.component.ts